import React,{useState, useEffect, useContext, useRef} from 'react'
import './WeldAnalysis.css'
import InputBar from '../minda/InputBar/InputBar';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Select from "react-select";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from 'react-redux';
import AnalycticTable from './AnalycticTable';
import { isIsoDate, jsonToURL, host } from '../../../../utils';
import { ConfigContext } from '../../../../App';
import { faRuler,faWeight, faClock, faCheckCircle, faChartLine, faChartBar, faBed, faCut, faLightbulb,faAngleDoubleDown, faTimes,  } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from 'axios';


export default function WeldAnalysis(){

  const { companyId, mmHost } = useContext(ConfigContext);
  const [loading, setloading] = useState(false)
  const [fetchStatus, setFetchStatus] = useState(false)
  const [fetchStatus1, setFetchStatus1] = useState(false)
  const [weldAnalysisData, setWeldAnalysisData] = useState([])
  const [lastMachineOfLine, setLastMachineOfLine] = useState({machineType : "", machineId : ""})
  const [liveData, setLiveData] = useState([])
  const [showManualReworkModal, setShowManualReworkModal] = useState(false)
  const [manualReworkCount, setManualReworkCount] = useState("")
  const [totalDowntimeOfLine, setTotalDownTimeOfLine] = useState("")
  

const updateReworkCountBtn =()=>{
  console.log("this is the manually set rework count value : ",manualReworkCount);
}
  

  ////////  manual rework count modal logic//////
  const onReworkBtnClick = () =>{
    setShowManualReworkModal(true)
  }

  const closeManualReworkModal = () =>{
    setShowManualReworkModal(false)
  }


    const liveBlinkIcon =  <div className="blink"></div>

    let plantId = useSelector((state) => state.saveSelectedPlant);
  if (plantId.weldAnalysis) {
    plantId = plantId.weldAnalysis.selectedOption.value;
  } else {
    plantId = "";
  }

  let lineId = useSelector((state) => state.saveSelectedLine);
  if (lineId.weldAnalysis) {
    lineId = lineId.weldAnalysis.selectedOption.value;
  } else {
    lineId = "";
  }

  let timings = useSelector((state) => state.timings);
  timings = timings.weldAnalysis;
  let startTime = 1;
  let endTime = 1;
  if (timings) {
    startTime = timings.startTime.toISOString();
    endTime = timings.endTime.toISOString();
  }
  let queryParams = {
    startTime,
    endTime,
    plantId,
    lineId,
  };

const updateData = async () => {
  if (!isIsoDate(queryParams.startTime) || !isIsoDate(queryParams.endTime)) {
    throw "INVALID TIME FORMAT";
    return;
  }

  let weldAnalysisURL = `${mmHost}/chartserver/weldAnalysis?${jsonToURL(
    queryParams
  )}`;

  console.log("its your URL : ",weldAnalysisURL);

  if (
    plantId == "" ||
    lineId == "" ||
    !startTime ||
    !endTime
  ) {
    if (!startTime || !endTime) {
      // toast.error("Invalid Time Range", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      return;
    }

    // toast.info("Please Select All 5 Plant, Line, Machine, Shift and Shift Date", {
    //   position: toast.POSITION.TOP_LEFT,
    // });
    return;
  }

  setloading(true);
  await axios
    .get(weldAnalysisURL)
    .then(function(data){
      const result = data.data.res;
      const dataResponse = result["data"]
      const dataOfLastMachineOfLine = dataResponse.hsqn
      const machineAnalysisReport = dataResponse.report_1
      setLastMachineOfLine({machineType : dataOfLastMachineOfLine.machineType, machineId : dataOfLastMachineOfLine.machineId})
      setWeldAnalysisData(machineAnalysisReport);
      //setloading(false);
      // toast.info("Downtime Loaded", {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      return;
    })
    .catch(() => {
      //setloading(false);
      // toast.error("Downtime couldn't load", {
      //   position: toast.POSITION.TOP_RIGHT,
      // });
      return;
    });
};

useEffect(() => {
  updateData();
}, [fetchStatus1]);

console.log("LastMachineOfLine : ", lastMachineOfLine);


////////////Fetching Downtime of the last machine in fetched line/////////////


function timeConvertMinToHours(n) {
  const num = n;
  const hours = (num / 60);
  const rhours = Math.floor(hours);
  const minutes = (hours - rhours) * 60;
  const rminutes = Math.round(minutes);
  return  rhours + " hours and " + rminutes + " minutes";
  }

let downtimeOfLastMachineQueryParams = {
  startTime,
  endTime,
  plantId,
  machineType : lastMachineOfLine.machineType,
  lineId,
  machineId : lastMachineOfLine.machineId
};

let downtimeOfLastMachineURL = `${mmHost}/chartserver/downtime?${jsonToURL(
  downtimeOfLastMachineQueryParams
)}`;

console.log("downtimeOfLastMachineURL : ",downtimeOfLastMachineURL);


const updateTotalDowntimeData = async() =>{
  //setloading(true)
  await axios
  .get(downtimeOfLastMachineURL)
  .then(function(data){
    const result = data.data
    const totalDowntimeInMin = result.totalDowntime
    const roundOfTotalDowntimeInMin = Math.round(totalDowntimeInMin)
    const convertedInhoursAndMin = timeConvertMinToHours(roundOfTotalDowntimeInMin)
    console.log("convertedInhoursAndMin : ",convertedInhoursAndMin);
    setTotalDownTimeOfLine(convertedInhoursAndMin)
     setloading(false);
    // toast.info("Downtime Loaded", {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
    return;
  })
  .catch(() => {
    setloading(false);
    // toast.error("Downtime couldn't load", {
    //   position: toast.POSITION.TOP_RIGHT,
    // });
    return;
  });
}


useEffect(()=>{
  updateTotalDowntimeData();
},[lastMachineOfLine])




///////////////////////########## FETCH LIVE DATA API CALL################///////////

// const fetchLiveData = ()=>{
//   setloading(true);
//   axios
//     .get("http://mm.thirdeye-ai.com/pplan?startDate=2022-06-30T00:00:01.000Z&endDate=2022-06-30T23:59:59.000Z&plantId=&lineId=")
//     .then(function(data) {
//       setLiveData(data.data);
//       setloading(false);
//       // toast.info("Downtime Loaded", {
//       //   position: toast.POSITION.TOP_RIGHT,
//       // });
//       return;
//     })
//     .catch(() => {
//       setloading(false);
//       // toast.error("Downtime couldn't load", {
//       //   position: toast.POSITION.TOP_RIGHT,
//       // });
//       return;
//     });
// }


      ////////////FETCH LIVE DATA IN EVERY 10 SECOND///////////

// useEffect(()=>{ 
//   fetchLiveData()
//   const interval=setInterval(()=>{
//     fetchLiveData()
//    },10000)  
//    return()=>clearInterval(interval)
// },[])




 


/////////////// Fetch sift dropdown in rework count according to the plant ///////////////

function updationAPI() {
  return axios.get(
    `${host}/plantInfo?i4Usage=true&plantCode=${queryParams.plantId}`
  );
}

const [options, setOptions] = useState([]);
const [selectedShift, setSelectedShift] = useState("")
let selectRef = null;

useEffect(async () => {
  if (selectRef) {
    selectRef.clearValue();
  }
  try {
    let res = await updationAPI();
    let array = res.data[0]["shifts"];
    let options = [];

    for (let i = 0; i < array.length; i++) {
      options.push({
        value: array[i]["shiftCode"],
        label: array[i]["shiftName"],
      });
    }
    setOptions(options);
  } catch (e) {
    console.error(e);
  }
}, [plantId])

function onChangeHandler(selectedOption) {
  if (selectedOption) {
    setSelectedShift(selectedOption.value);
   }
}


console.log("shiftOptinos : ",options);



  return ( 
    <>
    <div className="box box-default">
    <div className="box-header">
      <InputBar
        setData={setWeldAnalysisData}
        setFetchStatus={setFetchStatus}
        fetchStatus={fetchStatus}
        loading={loading}
        InsIden={"weldAnalysis"}
        machineType={false}
        line={true}
        machine={false}
        shift={false}
        shiftDate={false}
        startTime={false}
        endTime={false}
       // goback={{ show: goback == "true" ? true : false }}
      ></InputBar>
    </div>
    <br/><br />
    
    <div className='bg-gray'>  
       <div className="eight"><h1>Production Analysis</h1></div><br />
       
   <Tabs
      defaultActiveKey="liveData"
      id="fill-tab-example"
      className="light" 
      justify
    >
      <Tab eventKey="liveData"
       title = {<div className="blink_me">Live Data {liveBlinkIcon}</div>}
       >
      <div className="row">
       <AnalycticTable title = "Found Part Count" bg = "primary" icon={faClock}/>
       <AnalycticTable title = "Downtime" bg = "info" icon={faAngleDoubleDown}/>
       <AnalycticTable title = "Rework Count" bg = "warning" icon={faChartLine} onClick={onReworkBtnClick} />
       <AnalycticTable title = "Wire Length per machine" bg = "success" icon={faRuler} additionalMsg = "(Availability x Quality x Performance) x 100 %"/>
       <AnalycticTable title = "Wire(gram)/weld length" bg = "danger" icon={faWeight}/>
       <AnalycticTable title = "Quality rejection" bg = "dark" icon={faTimes}/>
    </div>  
      </Tab>
      <Tab eventKey="customSelection" title="Custom Selection">
        <br /><br />
        <InputBar
        setData={setWeldAnalysisData}
        setFetchStatus={setFetchStatus1}
        fetchStatus={fetchStatus1}
        loading={loading}
        InsIden={"weldAnalysis"}
        machineType={false}
        plant={"disable"}
        line={false}
        machine={false}
        shift={true}
        shiftDate={true}
        startTime={true}
        endTime={true}
      ></InputBar>
        {
          (fetchStatus1) ? " " : 
          (<div className='text-center'><h5>* Please select required field from input</h5></div>)
        } 
         <br />
        {
          fetchStatus1 && 
          <div className="row">
          <AnalycticTable resultValue = {weldAnalysisData.finalCount} title = "Found Part Count" bg = "primary" icon={faClock}/>
          <AnalycticTable title = "Downtime" resultValue = {totalDowntimeOfLine}  bg = "info" icon={faCheckCircle}/>
          <AnalycticTable resultValue = {weldAnalysisData.reworkCount} title = "Rework Count" bg = "warning" icon={faChartLine} onClick={onReworkBtnClick}/>
          <AnalycticTable title = "Wire Length per machine" resultValue = {weldAnalysisData.weldlenPerManDays} bg = "success" icon={faChartBar} additionalMsg = "(Availability x Quality x Performance) x 100 %"/>
          <AnalycticTable title = "Wire(gram)/weld length" resultValue = {weldAnalysisData.wiregramPerWeldLength} bg = "danger" icon={faBed}/>
          <AnalycticTable title = "Quality rejection" bg = "dark" icon={faCheckCircle}/>
       </div> 
        }
      </Tab>
    </Tabs>
</div>
</div>

{/* ///////////////////////Manually update rework count modal/////////////////// */}

<Modal show={showManualReworkModal} onHide={closeManualReworkModal}
dialogClassName='rework-modal'
aria-labelledby="example-custom-modal-styling-title"
>
        <Modal.Header closeButton>
            <Modal.Title>
               Manual Rework Count
            </Modal.Title>
      </Modal.Header>
         <Modal.Body>
         <div>
          Line : {queryParams.lineId}
          </div><br /><br />
         <Tabs
      defaultActiveKey="Shift A"
      id="modalTab"
      className="mb-3"
    >
      {
      options.map((data)=>(
         <Tab eventKey={data.label} title ={data.label} >
         <div>
            Fetched Rework count : {weldAnalysisData.reworkCount}
            </div><br />
            <label>Manually enter rework count : </label> &nbsp;
            <input type="Number" onChange={(e)=> setManualReworkCount(e.target.value)} value={manualReworkCount} />
     
         </Tab>
      ))  
    }
       </Tabs>

          {/* <div>
          Line : {queryParams.lineId}
          </div>
              <br/><hr /><br />
              <div className={"col-sm-6 col-md-4 col-lg-3"}>
        Select Shift{" "}
        <Select
          ref={(ref) => {
            selectRef = ref;
          }}
          //defaultValue={"ShiftA"}
          options={options}
          onChange={onChangeHandler}
        />
      </div>
              <div>
            Fetched Rework count : {weldAnalysisData.reworkCount}
            </div><br />
            <label>Manually enter rework count : </label> &nbsp;
            <input type="Number" onChange={(e)=> setManualReworkCount(e.target.value)} value={manualReworkCount} />
     
             */}
          </Modal.Body>
          <Modal.Footer>
        <Button onClick={closeManualReworkModal} variant="secondary">Close</Button>
        <Button variant="primary" onClick={updateReworkCountBtn}>Update</Button>
        </Modal.Footer>
    </Modal>

</>
  );
}













